import React from 'react';
import { X } from 'lucide-react';
export function PainSection() {
  return <section className="py-14 md:py-20 bg-negro" data-id="element-308">
      <div className="container" data-id="element-309">
        <div className="grid grid-cols-2 gap-10 items-center max-md:grid-cols-1 max-md:gap-8" data-id="element-310">
          <div data-id="element-311">
            <div className="section-label" data-id="element-312">¿Te identificas?</div>
            <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco" data-id="element-313">
              El poder invisible que
              <br data-id="element-314" />
              mueve a las personas
            </h2>
            <ul className="mt-7 list-none" data-id="element-315">
              <li className="flex items-start gap-3.5 py-4 border-b border-[rgba(255,255,255,.06)] text-[.95rem] text-crema-oscuro" data-id="element-316">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-317">
                  <X className="w-3.5 h-3.5" data-id="element-318" />
                </span>
                <span data-id="element-319">
                  Sientes que otros logran lo que quieren con facilidad mientras
                  tú luchas por ser escuchado.
                </span>
              </li>
              <li className="flex items-start gap-3.5 py-4 border-b border-[rgba(255,255,255,.06)] text-[.95rem] text-crema-oscuro" data-id="element-320">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-321">
                  <X className="w-3.5 h-3.5" data-id="element-322" />
                </span>
                <span data-id="element-323">
                  Has sido manipulado sin darte cuenta — en el trabajo, en
                  relaciones, en decisiones de compra.
                </span>
              </li>
              <li className="flex items-start gap-3.5 py-4 border-b border-[rgba(255,255,255,.06)] text-[.95rem] text-crema-oscuro" data-id="element-324">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-325">
                  <X className="w-3.5 h-3.5" data-id="element-326" />
                </span>
                <span data-id="element-327">
                  Quieres influir con más impacto pero no sabes qué mecanismos
                  psicológicos activar.
                </span>
              </li>
              <li className="flex items-start gap-3.5 py-4 text-[.95rem] text-crema-oscuro" data-id="element-328">
                <span className="w-[34px] h-[34px] min-w-[34px] bg-[rgba(139,26,26,.2)] border border-[rgba(139,26,26,.3)] rounded-full flex items-center justify-center text-rojo-vivo" data-id="element-329">
                  <X className="w-3.5 h-3.5" data-id="element-330" />
                </span>
                <span data-id="element-331">
                  Crees que aprender estas técnicas es "poco ético" — cuando
                  ignorarlas es lo que te pone en desventaja.
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-332">
            <div className="bg-negro-suave border border-[rgba(201,151,43,.15)] rounded-lg overflow-hidden" data-id="element-333">
              <img src="https://i.postimg.cc/FHMF86Cw/U63-ADl-E7-RZSm-EJ4-y-JP1-1-min.png" alt="Psicología oscura" className="w-full block" data-id="element-334" />
              <div className="py-[18px] px-[22px] font-cormorant italic text-[1rem] text-dorado-palido text-center" data-id="element-335">
                "El conocimiento de la influencia es neutral. El poder lo define
                quien lo posee."
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}